import React from "react";
import "./Book_Vehicle.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Book_Vehicle = () => {
    return (
        <section className="Book_Vehicle">
            <div className="banner">
                <div className="content">
                    <h1 className="title">
                        Book Your Vehicle Service <br />
                        <span className="title-xl">in Just a Few Clicks!</span>
                    </h1>

                    <p className="subtitle">
                        From maintenance and towing to inspections and repairs —
                        <strong> KK Group </strong> brings convenience, trust, and innovation right to your doorstep.
                        Let us handle the work while you enjoy a hassle-free driving experience.
                    </p>

                    <div className="badge">
                        <a
                            href="https://play.google.com/store/apps/details?id=com.mobile.gravity_drive&pcampaignid=web_share"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/assets/images/book_your_vehicle/google_play.png"
                                alt="Get it on Google Play"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Book_Vehicle;
